import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinStandbyFlightAvailabilitySubHeaderComponent } from './checkin-standby-flight-availability-sub-header.component';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';
import { IfScreenSizeModule } from '@common/directives/if-screen-size/if-screen-size.module';

@NgModule({
  declarations: [CheckinStandbyFlightAvailabilitySubHeaderComponent],
  imports: [CommonModule, IfScreenSizeModule, RouterModule, StaticMsgModule],
  exports: [CheckinStandbyFlightAvailabilitySubHeaderComponent],
})
export class CheckinStandbyFlightAvailabilitySubHeaderModule {}
